<div [class.status-bar]="true" [class.colored]="colored">
    <ng-content></ng-content>
</div>